module.exports = __webpack_public_path__ + "img/Feature.9cbe7972.jpg";